/**
 * Generic View component to be used with react-native integration.
 */
var View = function View() {};

View.propTypes = {};
View.defaultProps = {};
export default View;